<template>

  <div class="panel">
    <b-field class="file">
      <b-upload v-model="file" @input="validateAndConfirm">
        <a class="button is-primary">
          <b-icon icon="upload" custom-size="default"></b-icon>
          <span>{{ buttonLabel }}</span>
        </a>
      </b-upload>
      <span class="file-name" v-if="file">{{ file.name }}</span>
      <b-loading :is-full-page="isFullPage" :active.sync="isLoading" />
    </b-field>

  </div>

</template>

<script>
import TemplateRepository from '@/services/TemplateRepository'

export default {
  name: 'UploadTemplate',
  data () {
    return {
      file: null,
      uploadPercent: 0,
      isLoading: false,
      isFullPage: true,
      totalAcknowledgments: 0
    }
  },
  computed: {
    buttonLabel () {
      return !this.file ? 'Importar CSV o XLSX' : 'Importar otro CSV o XLSX'
    }
  },
  methods: {
    validateAndConfirm (file) {
      this.$emit('input', file)
      if (!this.file.name.endsWith('.csv') && !this.file.name.endsWith('.xlsx')) {
        this.$buefy.toast.open({
          message: 'El documento a subir debe de ser un archivo .CSV o .XLSX',
          type: 'is-danger'
        })
        this.file = null
        return
      }
      this.$buefy.dialog.confirm({
        message: '¿Quieres subir el archivo ' + this.file.name + '?',
        onConfirm: () => this.upload(file),
        cancelText: 'Cancelar',
        confirmText: 'Confirmar'
      })
    },
    upload (file) {
      this.isLoading = true
      TemplateRepository.uploadTemplate(file)
        .then(r => {
          this.file = null
          this.$buefy.toast.open({
            message: 'Cargando Usuarios',
            type: 'is-info'
          })
          this.confirmUpload(r.data.id)
        })
        .catch(err => {
          this.file = null
          this.isLoading = false
          this.$buefy.toast.open({
            message: 'Parece que ha ocurrido un problema',
            type: 'is-danger'
          })
          if (err.response.status === 400) {
            this.$buefy.dialog.alert({
              title: 'CSV con errores',
              message: err.response.data,
              type: 'is-danger',
              hasIcon: true,
              confirmText: 'Aceptar'
            })
          } else if (err.response.status === 401) {
            this.$router.push('login')
          } else {
            this.isLoading = false
            this.$buefy.toast.open({
              message: `Error: ${err.message}`,
              type: 'is-danger'
            })
          }
        })
    },
    confirmUpload (id) {
      TemplateRepository.confirmUpload(id, { state: 'LOADED' })
        .then(r => {
          this.isLoading = false
          this.$buefy.dialog.alert('Cargada exitosa de usuarios!')
        }).catch(e => {
          this.isLoading = false
          this.$buefy.dialog.alert({
            title: 'Se ha cargado parcialmente el archivo',
            message: e.response.data.detail,
            type: 'is-warning',
            hasIcon: true,
            confirmText: 'Aceptar'
          })
        })
    }
  }
}
</script>
